import Vue from 'vue';
import VueResource from 'vue-resource';
import router from '@/router';
import jwt from 'jsonwebtoken';
import {store} from "../../index";

Vue.use(VueResource);

export const fncAuthorizeLogin = ({ commit, dispatch, state, rootState }, payload) => {
	var authDetails = { username: payload.username, pwd: payload.password };
	state.sendingLoginAuth = true;
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=authenticate_user', authDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
			state.sendingLoginAuth = false;
			if (data.error) {
				state.loginStatus = true;
				var snackDetails = {color: 'error', message: 'User could not be authenticated', display: true};
				commit('setSnack', snackDetails);
			} else {
				state.loginStatus = false;
				if (data.length == 1) {

          const spineStatus = {
              PUBLISHED: 0,
              UNPUBLISHED: 1
          };

          if( data[0].module_spine_published == 1 ) {
            data[0].module_spine_published = spineStatus.PUBLISHED; 
          } else {
            data[0].module_spine_published = spineStatus.UNPUBLISHED;
          }

					dispatch('fncSpineSetup', data[0]);
				} else {
					state.hasAccountSelect = true;
					commit('fncGetAccountList', data);
				}
			}
		});
};

export const fncRequestCode = ({commit, dispatch, state, rootState}, payload) => {
	state.requestSent = true;
	var accountDetails = { params: { email: payload.email } };
	var validationDetails = { params: { password: payload.password } };

  Vue.http.post( window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=validate_password', validationDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(validation => {
        if (validation === true){

          Vue.http.post( window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=get_account_list', accountDetails, rootState.headerDetails)
            .then(response => {
              return response.json();
            }, error => {
              console.log(error);
            }).then(data => {

              console.log('Login Length');
              console.log( data.length );

            if( data.length == 0 ) {
              var snackDetails = {color: 'error', message: 'Your account could not be found.', display: true };
              commit('setSnack', snackDetails);
            } else if( data.length == 1 ) {
              var snackDetails = {color: 'success', message: 'Password instructions sent, please contact support if not received.', display: true };
              commit('setSnack', snackDetails);
            }

            commit('fncGetAccountList', data);
            commit('fncRequestCode', data);
          });

        }
        else {
          state.requestSent = false;
          var snackDetails = {color: 'error', message: 'Password must be at least 8 characters, 1 capital letter and 1 numeric number.', display: true};
          commit('setSnack', snackDetails);
        }
  });

};

export const fncSendCode = ({ commit, state, rootState }, payload) => {

	var account = payload.account.id != null ? payload.account.id : payload.account;

	var codeDetails = { params:  { email: payload.email, user: account } };
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=request_reset_code', codeDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
			if( data == true ) {
				state.hasCodeEmailed = true;
			}
		});
}

export const fncResetPassword = ({commit, state, rootState}, payload) => {
	state.resetSent = true;
	state.resetError = false;
	var account = payload.account.id != null ? payload.account.id : payload.account;
	var resetDetails = {params: { user: account, reset_code: payload.code, password: payload.password }};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=reset_password', resetDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
			commit('fncResetPassword', data);
			if( data.msg == 'Success' ) {
				var snackDetails = {color: 'success', message: 'Your password has been reset successfully', display: true};
				commit('hideModal');
			} else {
				var snackDetails = {color: 'error', message: 'Please enter the correct code for the associated email address', display: true};
			}
			commit('setSnack', snackDetails);
		});
}

export const fncClearLogin = ({commit, dispatch, state}) => {
	state.hasAccountSelect = false;
}

export const fncGetAccountList = ({commit, state}, payload)  => {
	commit('fncGetAccountList', payload);
}

export const fncSpineSetup = ({ commit, state, rootState }, payload) => {

  var authDetails = { manufacturer: payload.manufacturer, user: payload.id };

  commit('fncSetSetManufacturer', payload.manufacturer);

  Vue.http.headers.common['X-Manufacturer'] = String(payload.manufacturer);

  var tokenUrl = window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=generate_token_myorder';

  if( payload.type == '2' || payload.type == '4' ) {
    tokenUrl = window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=generate_token_customer';
  }

  Vue.http.post(tokenUrl, authDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(tdata => {

    Vue.http.headers.common['X-Token'] = tdata.token;

    if( payload != undefined && (String(payload.type) == '2' || String(payload.type) == '4') ) {
      payload.vendorActive = 0;

      var tokenString = JSON.stringify(payload);
      var token = jwt.sign(tokenString, 'shhhhh');
      var snackDetails = { color: '', message: '', display: false };
      var loginDetails = { spineToken: '', jwtToken: token, objAuth: payload, snackDetails: snackDetails };

      commit('setLoginDetails', loginDetails);
      router.replace('/customer-setup');
      return;
    }

    Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        console.log(error);
      }).then(data => {
      var userDetails = {user: payload.id};
      Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=create_session', userDetails, rootState.headerDetails)
        .then(response => {
          return response.json();
        }, error => {
          console.log(error);
        }).then(dt => {
        if( dt === null ) {

          if( payload.type == 2 || payload.type == 4 ) {

              router.replace('/customer-setup');

          } else {

              var auditDetails = {type: 'user_login', prev_value: '', new_value: '', user: payload.id, target: '', data: '', save: 'true'};
              Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Audit.php?a=add', auditDetails, rootState.headerDetails )
                .then(response => {
                  return response.json();
                }, error => {
                  console.log(error);
                }).then(d => {
                var auditResult = JSON.parse( d );
                if (auditResult.msg === 'success') {

                  var vendorDetails = { manufacturer: payload.manufacturer };
                  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php?a=getManufacturerVendors', vendorDetails, rootState.headerDetails)
                    .then(response => {
                      return response.json();
                    }, error => {
                      console.log(error);
                    }).then(data => {

                    var vendorActive = 0;
                    if (data.length > 0) { vendorActive = 1 }

                    payload.vendorActive = vendorActive;

                    var tokenString = JSON.stringify(payload);
                    var token = jwt.sign(tokenString, 'shhhhh');
                    var snackDetails = { color: '', message: '', display: false };
                    var loginDetails = { spineToken: data.token, jwtToken: token, objAuth: payload, snackDetails: snackDetails }
                    commit('setLoginDetails', loginDetails);
                    if (payload.type == '6') { console.log('6')
                      router.replace('/dashboard/landing');
                    } else {
                      if(payload.privileges.indexOf('VIEW_WIDGETS') == -1) {console.log('wiget')
                        router.replace('dashboard/landing');
                      }
                      else if(payload.privileges.indexOf('VIEW_QUOTES') == -1) {console.log('quote')
                        router.replace('reports/sales-order-reports?p=1');
                      } else {console.log('else')
                        router.replace('dashboard/landing');
                      }
                    }
                    // router.replace('/');
                  });

                } else {
                  var snackDetails = {color: 'error', message: 'User could not be authenticated', display: true};
                  commit('setSnack', snackDetails);
                }
              });

          }

        }
      });
    });

  });

	/*Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
			var userDetails = {user: payload.id};
			Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=create_session', userDetails, rootState.headerDetails)
			.then(response => {
				return response.json();
			}, error => {
				console.log(error);
			}).then(dt => {
				if( dt === null ) {
					var auditDetails = {type: 'user_login', prev_value: '', new_value: '', user: payload.id, target: '', data: '', save: 'true'};
					Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Audit.php?a=add', auditDetails, rootState.headerDetails )
					.then(response => {
						return response.json();
					}, error => {
						console.log(error);
					}).then(d => {
						var auditResult = JSON.parse( d );
						if (auditResult.msg === 'success') {

							var vendorDetails = { manufacturer: payload.manufacturer };
							Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Vendor.php?a=getManufacturerVendors', vendorDetails, rootState.headerDetails)
								.then(response => {
									return response.json();
								}, error => {
									console.log(error);
								}).then(data => {

									var vendorActive = 0;
									if (data.length > 0) { vendorActive = 1 }

									payload.vendorActive = vendorActive;

									var tokenString = JSON.stringify(payload);
									var token = jwt.sign(tokenString, 'shhhhh');
									var snackDetails = { color: '', message: '', display: false };
									var loginDetails = { spineToken: data.token, jwtToken: token, objAuth: payload, snackDetails: snackDetails }
									commit('setLoginDetails', loginDetails);
									if (payload.type == '6') { console.log('6')
										router.replace('/dashboard/landing');
									} else {
                    if(payload.privileges.indexOf('VIEW_WIDGETS') == -1) {console.log('wiget')
                      router.replace('dashboard/landing');
                    }
									  else if(payload.privileges.indexOf('VIEW_QUOTES') == -1) {console.log('quote')
                      router.replace('reports/sales-order-reports?p=1');
                    } else {console.log('else')
                      router.replace('dashboard/landing');
                    }
									}
                  // router.replace('/');
								});

						} else {
							var snackDetails = {color: 'error', message: 'User could not be authenticated', display: true};
							commit('setSnack', snackDetails);
						}
					});
				}
			});
		});*/
}

export const fncLogout = ({commit, state}) => {
	var snackDetails = {color: '', message: '', display: false};
	var loginDetails = {spineToken: '', jwtToken: '', objAuth: '', snackDetails: snackDetails};
	commit('setLoginDetails', loginDetails);
	window.location = '';
	//router.replace('/login');
}

export const fncPopulateTokens = ({commit, state, rootState}, payload) => {

  var objAuth = JSON.parse(rootState.objAuthorize);
  var tokenDetails = {manufacturer: objAuth.manufacturer};

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Audit.php?a=get_tokens', tokenDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
      commit( 'fncSetTokenList', data );
  });
}

export const fncAddToken = ({commit, dispatch, state, rootState}, payload) => {

  var objAuth = JSON.parse(rootState.objAuthorize);
  var tokenDetails = {token_name: payload.tokenName, token_value: payload.tokenValue, manufacturer: objAuth.manufacturer};

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Audit.php?a=add_token', tokenDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
      if( data == true ) {
        var snackDetails = {color: 'success', message: 'The token has been created successfully', display: true};
        commit('hideModal');
        commit('fncEmptyTokens');
        dispatch('fncPopulateTokens');
      } else {
        var snackDetails = {color: 'error', message: 'There was an error creating the token', display: true};
      }
      commit('setSnack', snackDetails);
  });
}

export const fncTokenDelete = ({commit, dispatch, state, rootState}, payload) => {

  var tokenDetails = {token_id: payload.token.t_id};

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Audit.php?a=delete_token', tokenDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
      if( data == true ) {
        var snackDetails = {color: 'success', message: 'The token has been deleted successfully', display: true};
      } else {
        var snackDetails = {color: 'error', message: 'There was an error deleting the token', display: true};
      }
      commit('setSnack', snackDetails);
      dispatch('fncPopulateTokens');
  });
}

export const fncUpdateToken = ({commit, dispatch, state, rootState}, payload) => {

  var tokenDetails = payload;

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Audit.php?a=edit_token', tokenDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
      if( data == true ) {
        var snackDetails = {color: 'success', message: 'The token has been edited successfully', display: true};
        commit('hideModal');
        commit('fncEmptyTokens');
        dispatch('fncPopulateTokens');
      } else {
        var snackDetails = {color: 'error', message: 'There was an error editing the token', display: true};
      }
      commit('setSnack', snackDetails);
  });
}

export const fncAutoLogin = ({commit, dispatch, state, rootState}, payload) => {
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=auto_login', payload, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
      if( data != null ) {
        if( data[0].id > 0 && data.error == null ) {
          data[0].quoteno = payload.quoteno;
          data[0].salesorder = true;
          dispatch('fncSpineSetup', data[0]);
          localStorage.setItem('appUrl', payload.b);
          //commit('fncSetAppUrl', payload.b);
        }
      } else {
        //alert('Issue');
      }
  });
}

export const fncRunSpinInstallationImport = ({commit, dispatch, state, rootState}, payload) => {

  var objAuth = JSON.parse(rootState.objAuthorize);

  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured', display: true };
      commit('setSnack', snackDetails);
      console.log(error);
    }).then(sdata => {

    var tokenDetails = { token: sdata.token, retailer_id: '1', limit: 1000000 };
    Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/articles', { params: tokenDetails }, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error has occured', display: true };
        commit('setSnack', snackDetails);
        console.log(error);
      }).then(sdt => {

        var installationsDetails = [];

        for( var s in sdt ) {
          if( sdt[s].vendor == objAuth.installer_name && sdt[s].released == true ) {
            installationsDetails.push({ description: sdt[s].article_description, code: sdt[s].article_number })
          }
        }

      var payloadFromSpine = { manufacturer: payload, articles: installationsDetails };

      Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=importInstallationDetails', payloadFromSpine, rootState.headerDetails)
        .then(response => {
          return response.json();
        }, error => {
          console.log(error);
        }).then(data => {


          var jsonDetails = JSON.stringify( installationsDetails );

          commit('setInstallations', jsonDetails);

        var snackDetails = {color: 'success', message: 'Installation Articles have been imported', display: true};
        commit('setSnack', snackDetails);

      });
    });

  });

}

export const fncSaveManualInstallations = ({commit, dispatch, state, rootState}, payload) => {

  var objAuth = JSON.parse(rootState.objAuthorize);

  var payloadFromSpine = { manufacturer: objAuth.manufacturer, articles: payload };

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=importManualInstallationDetails', payloadFromSpine, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

      commit('setManualInstallations', payload);

    var snackDetails = {color: 'success', message: 'Manual Installation Articles have been updated', display: true};
    commit('setSnack', snackDetails);

  });

}

